import { Box } from '@mui/material';

import { GetUserByIdResponse } from '@/hooks/useUserById';

interface UserInformationTabProps {
  user?: GetUserByIdResponse;
}

function UserInformationTab({ user }: UserInformationTabProps) {
  return (
    user && (
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: '64px' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <Box
            component='span'
            sx={{
              fontSize: '12px',
              fontWeight: 400,
              lineHeight: '16px',
              textTransform: 'uppercase',
              color: '#4D4D4D',
            }}
          >
            EMAIL
          </Box>
          <Box
            component='span'
            sx={{
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: '20px',
              color: '#000000',
            }}
          >
            {user.email || 'N/A'}
          </Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <Box
            component='span'
            sx={{
              fontSize: '12px',
              fontWeight: 400,
              lineHeight: '16px',
              textTransform: 'uppercase',
              color: '#4D4D4D',
            }}
          >
            STATUS
          </Box>
          <Box
            component='span'
            sx={{
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: '20px',
              color: '#000000',
              textTransform: 'capitalize',
            }}
          >
            {user.status?.toLowerCase() || 'N/A'}
          </Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <Box
            component='span'
            sx={{
              fontSize: '12px',
              fontWeight: 400,
              lineHeight: '16px',
              textTransform: 'uppercase',
              color: '#4D4D4D',
            }}
          >
            COUNTRY CODE
          </Box>
          <Box
            component='span'
            sx={{
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: '20px',
              color: '#000000',
            }}
          >
            {user.countryCode || 'N/A'}
          </Box>
        </Box>
      </Box>
    )
  );
}

export default UserInformationTab;
